import { configureStore } from '@reduxjs/toolkit';
import LoginSlice from './slices/LoginSlice';
import PaginationSlice from './slices/PaginationSlice';
import WarehouseSlice from './slices/WarehouseSlice';
import ProductSlice from './slices/ProductSlice';
import RecipeSlice from './slices/RecipeSlice';
import { loadFromSessionStorage, StorageKey } from '../storage/SessionStorage';
import MenuDaySlice from './slices/MenuDaySlice';

const preloadedState = () => ({
    login: {
        roles: loadFromSessionStorage(StorageKey.roles) || [],
        username: loadFromSessionStorage(StorageKey.username),
    },
});

const constructStore = () => {
    return configureStore({
        reducer: {
            login: LoginSlice,
            pagination: PaginationSlice,
            warehouse: WarehouseSlice,
            product: ProductSlice,
            recipe: RecipeSlice,
            menuDay: MenuDaySlice,
        },
        preloadedState: preloadedState(),
    });
};

const store = constructStore();
export default store;
